import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["acceptModal", "rejectModal", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Button, Modal } from '@elements';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ConfirmModal = function ConfirmModal(_ref) {
  var acceptModal = _ref.acceptModal,
      rejectModal = _ref.rejectModal,
      data = _ref.data,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Modal, {
    children: [/*#__PURE__*/_jsx(Modal.Title, _objectSpread(_objectSpread({}, props), {}, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        fontWeight: 700,
        children: data === null || data === void 0 ? void 0 : data.title
      })
    })), /*#__PURE__*/_jsx(Modal.Content, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body1",
        fontWeight: 400,
        children: data === null || data === void 0 ? void 0 : data.body
      })
    }), /*#__PURE__*/_jsx(Modal.Footer, {
      children: /*#__PURE__*/_jsxs(Stack, {
        direction: "row",
        gap: 1.5,
        justifyContent: "flex-end",
        children: [/*#__PURE__*/_jsx(Button, {
          variant: "contained",
          color: "secondary",
          size: "small",
          onClick: rejectModal,
          children: t('modals.buttons.cancel')
        }), /*#__PURE__*/_jsx(Button, {
          variant: "contained",
          size: "small",
          onClick: acceptModal,
          children: (data === null || data === void 0 ? void 0 : data.acceptBtnText) || t('modals.buttons.yes')
        })]
      })
    })]
  });
};